import moduleLinks from '../config/links';
import axios from 'axios';
import typeToReducer from 'type-to-reducer';
import { keyBy } from 'lodash';
import { SUCCESS } from 'containers/App/configureStore';
import { getPreferenceSettingValue, PREFERENCE_SETTING_KEYS } from 'containers/App/reducers/applicationReducer';
const path = 'tube/';
const initialState = Object.assign({ data: keyBy(moduleLinks, 'id') }, { timer: undefined });
const FETCH_LINK_COUNT = `${path}FETCH_LINK_COUNT`;
const START_TIMER = `${path}START_TIMER`;
const STOP_TIMER = `${path}STOP_TIMER`;
const UPDATE_LINK_URL = `${path}UPDATE_LINK_URL`;
const reducer = {
  [START_TIMER]: (state, action) => {
    return Object.assign({}, state, { timer: action.timer });
  },
  [STOP_TIMER]: (state) => {
    clearInterval(state.timer);
    return Object.assign({}, state, { timer: undefined });
  },
  [UPDATE_LINK_URL]: (state, action) => {
    const { linkId, newUrl } = action;
    const links = state.data;

    if (links[linkId]) {
      links[linkId] = Object.assign({}, links[linkId], { url: newUrl });
    }

    return Object.assign({}, state, { data: links });
  },
};

moduleLinks.forEach((link) => {
  reducer[`${FETCH_LINK_COUNT}_${link.id}`] = {
    [SUCCESS]: (state, action) => {
      const links = state.data;

      if (links[link.id] === undefined) {
        return state;
      }

      links[link.id] = Object.assign({}, links[link.id], { count: action.payload.data.data });
      return Object.assign({}, state, { data: links });
    },
  };
});

export default typeToReducer(reducer, initialState);

export function fetchLinksCount() {
  return (dispatch, getState) => {
    const links = getState().app.tube.index.links.data;
    Object.values(links).forEach((link) => {
      if (link.messageApi) {
        dispatch({
          type: `${FETCH_LINK_COUNT}_${link.id}`,
          payload: axios.get(link.messageApi),
        });
      }
    });
  };
}

export function startLinkCountTimer() {
  return (dispatch) => {
    dispatch(fetchLinksCount());
    const timer = setInterval(() => {
      dispatch(fetchLinksCount());
    }, 600000);
    return dispatch({
      type: START_TIMER,
      timer,
    });
  };
}

export function stopLinkCountTimer() {
  return {
    type: STOP_TIMER,
  };
}

export function updateLinkUrl(linkId, newUrl) {
  return {
    type: UPDATE_LINK_URL,
    linkId,
    newUrl,
  };
}

export function checkAndUpdateScheduleLink() {
  return (dispatch, getState) => {
    const {
      app: {
        application: { preferenceSettings },
        tube: { index: { links } },
      },
    } = getState();

    // 使用 preferenceSettings 判斷是否啟用新版 UI
    // 當 UseNewUI 為 'true' 時才走新版，其他情況（null、'false'、API 失敗）都走舊版
    const useNewUI = getPreferenceSettingValue(preferenceSettings, PREFERENCE_SETTING_KEYS.USE_NEW_UI) === 'true';

    if (useNewUI) {
      // 找到新排班 link 物件
      const targetLink = Object.values(links.data).find(
        link => link.i18nKey === 'SH_WorkTimetableForApproval'
      );

      if (targetLink && targetLink.url !== '/schedule') {
        dispatch(updateLinkUrl(targetLink.id, '/schedule'));
      }
    }
    // 如果 useNewUI 為 false 或 null，保持原本的 URL，不做任何修改（預設走舊版）
  };
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Index/reducers/linkReducer.js
 **/